import React from 'react';
import './EstadoCarregando.css';

/**
 * Indicador de carregamento padronizado.
 *
 * Props:
 * - mensagem: texto exibido abaixo do spinner (padrão: "Carregando...")
 * - inline: quando true, renderiza em formato compacto (sem padding de página)
 * - linhas: quando informado (> 0), renderiza um skeleton de N linhas no lugar do spinner
 */
function EstadoCarregando({ mensagem = 'Carregando...', inline = false, linhas = 0 }) {
  const classe = inline ? 'estado-carregando estado-carregando--inline' : 'estado-carregando';

  if (linhas > 0) {
    return (
      <div className={classe} role="status" aria-live="polite">
        <div className="estado-carregando__skeleton">
          {Array.from({ length: linhas }).map((_, i) => (
            <div key={i} className="estado-carregando__skeleton-linha" />
          ))}
        </div>
        <span className="sr-only">{mensagem}</span>
      </div>
    );
  }

  return (
    <div className={classe} role="status" aria-live="polite">
      <div className="estado-carregando__spinner" aria-hidden="true" />
      {mensagem && <p className="estado-carregando__mensagem">{mensagem}</p>}
    </div>
  );
}

export default EstadoCarregando;
